<script setup lang="ts">
import { TheTooltip } from '@wastedondestiny/destiny-library'

defineProps<{ item?: Item }>()
</script>

<template>
  <div v-if="item" class="h-8 w-8 border-yellow-400 border-2 box-content transition-shadow duration-100 shadow-[0_0_4px] shadow-yellow-400 hover:shadow-[0_0_8px]">
    <TheTooltip>
      <div class="relative block w-8 h-8">
        <img class="absolute w-full h-full" :alt="`${item.name} icon`" :src="`/generated/${item.icon}`" />
        <img v-if="item.watermark" class="absolute w-full h-full" alt="" :src="`/generated/${item.watermark}`" />
      </div>
      <template #icon>
        <img class="absolute w-12 h-12" :alt="`${item.name} icon`" :src="`/generated/${item.icon}`" />
        <img v-if="item.watermark" class="absolute w-12 h-12" alt="" :src="`/generated/${item.watermark}`" />
      </template>
      <template #content>
        <div class="clear-left" />
        <div class="w-64 -mt-9 ml-12">
          <h2 class="whitespace-nowrap">{{ item.name }}</h2>
          <span>{{ item.type }}</span>
        </div>
      </template>
    </TheTooltip>
  </div>
</template>